import { createSlice } from "@reduxjs/toolkit";

// Check if there is a value in localStorage
const getInitialValue = () => {
  const storedValue = localStorage.getItem('user');
  const userInfo = localStorage.getItem('userInfo');
  const clientDetails = localStorage.getItem('clientDetails');
  return storedValue
    ? {
        isAuth: true,
        user: JSON.parse(storedValue),
        userInfo: JSON.parse(userInfo),
        clientDetails: clientDetails ? JSON.parse(clientDetails) : null
      }
    : {
        isAuth: false,
        user: null,
        userInfo: { company: '', client: '' },
        clientDetails: null
      };
};

const initialState = getInitialValue();

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setClientDetails: (state, action) => {
      state.clientDetails = action.payload;
    },
    setAuth: (state) => {
      // Only authenticate if user data exists
      if (state.user) {
        state.isAuth = true;
      }
    },
    logout: state => {
      state.user = null;
      state.userInfo = null;
      state.clientDetails = null;
      state.isAuth = false;

      // Clear all localStorage items
      localStorage.removeItem('user');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('clientDetails');
      localStorage.removeItem('reference');
    }
  },
});

export const { setUser, logout, setUserInfo, setClientDetails, setAuth } = userSlice.actions;
export default userSlice.reducer;
